import { Locales } from "@/enums/enums";
import { i18n } from "@/i18n";
import { DepartmentDetailModel } from "@/model/department/departmentDetailModel";
import { DepartmentModel } from "@/model/department/departmentModel";
import { DepartmentTableModel } from "@/model/department/depatmentTableModel";
/* eslint-disable @typescript-eslint/camelcase */
export function ConvertToDepartmentDetail(departmentDetail: any): DepartmentDetailModel {
  const departmentDetailModal: DepartmentDetailModel = {
    id: departmentDetail.id,
    merchantId: departmentDetail.merchantId,
    code: departmentDetail.code,
    nameTh: departmentDetail.nameTh,
    nameEn: departmentDetail.nameEn,
    nameLocale: i18n.locale == Locales.TH ? departmentDetail.nameTh : departmentDetail.nameEn,
    isMain: departmentDetail.isMain,
    accountId: departmentDetail.accountId,
    type: departmentDetail.type,
    isArchived: departmentDetail.isArchived,
    isDeleted: departmentDetail.isDeleted,
  };
  return departmentDetailModal;
}

export function ConvertToDepartmentTable(table: any) {
  const departmentTable: any = {
    count: table.count,
    tableList: [],
  };

  if (table.tableList.length > 0) {
    table.tableList.forEach((tableItem: any) => {
      const departmentTableModel: DepartmentTableModel = {
        id: tableItem.id,
        code: tableItem.code,
        nameTh: tableItem.nameTh,
        nameEn: tableItem.nameEn,
        nameLocale: i18n.locale == Locales.TH ? tableItem.nameTh : tableItem.nameEn,
        isMain: tableItem.isMain,
        isArchived: tableItem.isArchived,
        accountId: tableItem.accountId,
        employeeCount: tableItem.employeeCount,
      };

      departmentTable.tableList.push(departmentTableModel);
    });
  }

  return departmentTable;
}

export function ConvertToDepartmentList(departmentList: any) {
  const departmentListModal: Array<DepartmentModel> = [];

  if (departmentList.length > 0) {
    departmentList.forEach((departmentItem: any) => {
      const departmentModel: DepartmentModel = {
        id: departmentItem.id,
        code: departmentItem.code,
        nameTh: departmentItem.nameTh,
        nameEn: departmentItem.nameEn,
        nameLocale: i18n.locale == Locales.TH ? departmentItem.nameTh : departmentItem.nameEn,
        isMain: departmentItem.isMain,
        accountId: departmentItem.accountId,
        type: departmentItem.type,
        isArchived: departmentItem.isArchived,
      };

      departmentListModal.push(departmentModel);
    });
  }

  return departmentListModal;
}
